import React, { FC, useEffect, useRef } from 'react';
import styled, { keyframes, css } from 'styled-components';

import { append } from '../../utils';

import { Spinner } from '../Spinner';
import { CosmosComponent } from '../../types';
import { colors } from '../../theme';

const durationMs = 500;
interface ContentProps extends CosmosComponent {
  isContentHidden?: boolean;
  loading?: boolean;
  contentClassName?: string;
  removePadding?: boolean;
}

export const SectionContent: FC<ContentProps> = ({
  isContentHidden,
  loading,
  contentClassName,
  children,
  testId,
  removePadding = false,
}) => {
  const collapseRef = useRef();

  useEffect(() => {
    const element = collapseRef.current as HTMLBaseElement;
    if (isContentHidden) {
      element.style.display = 'none';
    } else {
      element.style.display = '';
    }
    //`loading` and `children` are needed here, so we can recalculate max-height when content changes
  }, [isContentHidden, loading, children]);

  return (
    <CollapsibleWrapper
      ref={collapseRef}
      data-test-id={append(testId, 'content')}
      className={contentClassName}
    >
      {loading ? (
        <SpinnerWrapper>
          <Spinner isCentered testId={append(testId, 'spinner')} />
        </SpinnerWrapper>
      ) : (
        <CollapsibleContent removePadding={removePadding}>
          {children}
        </CollapsibleContent>
      )}
    </CollapsibleWrapper>
  );
};

const SpinnerWrapper = styled.div`
  background: ${colors.backgroundGray};
  border: 1px solid ${colors.borderGray};
  padding: 18px 28px;
  display: flex;
  justify-content: center;
`;

const expandMe = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const CollapsibleWrapper = styled.div`
  margin: 0;
  padding: 0;
  animation-name: ${expandMe};
  animation-duration: ${durationMs}ms;
`;

const CollapsibleContent = styled.div<{ removePadding: boolean }>`
  ${({ removePadding }) =>
    removePadding
      ? css`
          padding: 0rem;
        `
      : css`
          padding: 1.8rem 2.8rem;
        `}
`;
